"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Popover_1 = require("../../Popover");
var helpers_1 = require("../../helpers");
var controls_1 = require("../../controls");
var features_1 = require("../features");
var filterWithoutFakeColumns_1 = require("../utils/filterWithoutFakeColumns");
var ToggleMenu_1 = require("../../helpers/ToggleMenu");
var DotsIcon_1 = require("../icons/DotsIcon");
exports.toggleButtonBoxId = 'grid-toggle-button-box';
exports.togglerId = 'grid-toggler';
exports.toggleButtonId = 'grid-toggle-button';
exports.toggleMenuItemId = 'grid-toggle-menu-item';
var ButtonBox = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    right: 0;\n    box-sizing: border-box;\n    background-color: #ffffff;\n\n    display: flex;\n    align-items: center;\n\n    height: ", ";\n\n    ", "\n"], ["\n    position: absolute;\n    top: 0;\n    right: 0;\n    box-sizing: border-box;\n    background-color: #ffffff;\n\n    display: flex;\n    align-items: center;\n\n    height: ", ";\n\n    ",
    "\n"])), function (_a) {
    var headerHeight = _a.headerHeight;
    return headerHeight - 2 + "px";
}, function (_a) {
    var hasVerticalScroll = _a.hasVerticalScroll, scrollbarWidth = _a.scrollbarWidth;
    return hasVerticalScroll && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            padding-right: ", "px;\n        "], ["\n            padding-right: ", "px;\n        "])), scrollbarWidth);
});
var Button = styled_components_1.default.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border: none;\n    background: none;\n    height: ", "px;\n    width: ", "px;\n    padding: 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:focus,\n    &:hover,\n    &:active {\n        outline: none;\n    }\n\n    ", "\n"], ["\n    border: none;\n    background: none;\n    height: ", "px;\n    width: ", "px;\n    padding: 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:focus,\n    &:hover,\n    &:active {\n        outline: none;\n    }\n\n    ",
    "\n"])), helpers_1.GRID_TOGGLE_BUTTON_WIDTH, helpers_1.GRID_TOGGLE_BUTTON_WIDTH, function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return isActive
        ? styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                  background-color: ", ";\n              "], ["\n                  background-color: ", ";\n              "])), theme.colorHighlightDark) : styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                  &:hover {\n                      background-color: ", ";\n                  }\n                  &:active {\n                      background-color: ", ";\n                  }\n              "], ["\n                  &:hover {\n                      background-color: ", ";\n                  }\n                  &:active {\n                      background-color: ", ";\n                  }\n              "])), theme.colorHighlightLight, theme.colorHighlightDark);
});
var ToggleBtn = function (_a) {
    var toggleToggler = _a.toggleToggler, showToggler = _a.showToggler, togglerBtn = _a.togglerBtn, headerHeight = _a.headerHeight, scrollbarWidth = _a.scrollbarWidth, hasVerticalScroll = _a.hasVerticalScroll, disabled = _a.disabled;
    return (react_1.default.createElement(ButtonBox, { "data-selector-id": exports.toggleButtonBoxId, headerHeight: headerHeight, scrollbarWidth: scrollbarWidth, hasVerticalScroll: hasVerticalScroll },
        react_1.default.createElement(Button, { "data-selector-id": exports.toggleButtonId, onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                toggleToggler();
            }, isActive: showToggler, ref: togglerBtn, disabled: disabled },
            react_1.default.createElement(DotsIcon_1.DotsIcon, { isDisabled: disabled }))));
};
exports.updateHiddenColumns = function (_a) {
    var key = _a.key, isShow = _a.isShow, hiddenColumns = _a.hiddenColumns;
    return isShow ? hiddenColumns.filter(function (i) { return i !== key; }) : hiddenColumns.concat(key);
};
var GridToggler = function (_a) {
    var onClick = _a.onClick, columns = _a.columns, hiddenColumns = _a.hiddenColumns;
    return (react_1.default.createElement(ToggleMenu_1.ToggleMenu, null, columns.map(function (column, index) {
        if (!column.props.notToggleable) {
            var checked_1 = hiddenColumns.includes(column.key);
            return (react_1.default.createElement(ToggleMenu_1.ToggleMenuItem, { key: column.key + "-toggler", "data-selector-id": exports.toggleMenuItemId, title: column.props.title, isChecked: !checked_1, onChange: function () {
                    var currentColumn = {
                        isShow: checked_1,
                        toggledIndex: index,
                        columnId: column.props.columnId
                    };
                    onClick(exports.updateHiddenColumns({
                        key: column.key,
                        isShow: checked_1,
                        hiddenColumns: hiddenColumns
                    }), currentColumn);
                } }));
        }
        return null;
    })));
};
exports.GridToggleMenu = function () {
    var _a = react_1.useContext(features_1.GridContext).state, columns = _a.columns, headerHeight = _a.headerHeight, scrollbarWidth = _a.scrollbarWidth, hasVerticalScroll = _a.hasVerticalScroll, disabled = _a.disabled;
    var _b = features_1.useGridToggleableContext(), hiddenColumns = _b.hiddenColumns, setHiddenColumns = _b.setHiddenColumns, onColumnToggle = _b.onColumnToggle;
    var notFakeColumns = columns.filter(filterWithoutFakeColumns_1.filterWithoutFakeColumns);
    var control = controls_1.useDropdown({
        popoverConfig: [
            {
                xAxis: Popover_1.X_AXIS.insideRight,
                yAxis: Popover_1.Y_AXIS.outsideBottom,
                offsetY: (headerHeight - helpers_1.GRID_TOGGLE_BUTTON_WIDTH) / 2
            },
            {
                xAxis: Popover_1.X_AXIS.insideRight,
                yAxis: Popover_1.Y_AXIS.outsideTop,
                offsetY: helpers_1.SHADOWS_NORMAL_BLUR_RADIUS - (headerHeight - helpers_1.GRID_TOGGLE_BUTTON_WIDTH) / 2
            }
        ],
        renderControl: function (_a) {
            var button = _a.button, isActive = _a.isActive;
            return (react_1.default.createElement(ToggleBtn, { showToggler: isActive, togglerBtn: button.ref, toggleToggler: button.onMouseDown, headerHeight: headerHeight, scrollbarWidth: scrollbarWidth, hasVerticalScroll: hasVerticalScroll, disabled: disabled }));
        },
        renderPopover: function (_a) {
            var popover = _a.popover, content = _a.content;
            return (react_1.default.createElement("div", __assign({}, popover, { "data-selector-id": exports.togglerId }), content));
        },
        renderContent: function () { return (react_1.default.createElement(GridToggler, { columns: notFakeColumns, hiddenColumns: hiddenColumns, onClick: function (hiddenColumns, currentColumn) {
                setHiddenColumns(hiddenColumns);
                onColumnToggle(currentColumn);
            } })); }
    })[0];
    return control;
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=GridToggleMenu.js.map